import { render, staticRenderFns } from "./ResultsFourCorners.vue?vue&type=template&id=7b70925e&"
import script from "./ResultsFourCorners.vue?vue&type=script&lang=js&"
export * from "./ResultsFourCorners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports